import { motion } from "framer-motion";
import { tierColor } from "../lib/tiers";

export default function ScoreGauge({ score = 0, tier = "Fast", size = 200 }) {
  const pct = Math.max(0, Math.min(1, score / 1000));
  const r = size / 2 - 14;
  const c = 2 * Math.PI * r;
  const color = tierColor(tier);
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.07)" strokeWidth="12" fill="none" />
        <motion.circle
          cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth="12" fill="none"
          strokeLinecap="round" strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c - c * pct }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          style={{ filter: `drop-shadow(0 0 10px ${color}88)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono font-extrabold text-4xl" style={{ color }}>{score}</span>
        <span className="text-white/40 text-xs font-mono tracking-widest">/ 1000</span>
      </div>
    </div>
  );
}
